module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "appMain",
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('navbar', {
    attrs: {
      "show": true
    }
  }), _vm._v(" "), (_vm.isLogin) ? _c('sidebar', {
    attrs: {
      "show": _vm.sidebar.opened && !_vm.sidebar.hidden
    }
  }) : _vm._e(), _vm._v(" "), _c('app-main', {
    class: {
      'no-login': !_vm.isLogin
    }
  }), _vm._v(" "), (_vm.isLong) ? _c('back-top') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f14a6d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 641
// module chunks = 25